import React, { useEffect, useState } from 'react';

import { checkForActiveHunt } from '../helpers';
import SentimentModal from '../SentimentModal';
import * as styles from './RageHint.module.scss';

export default function RageHint() {
  const [isActiveHunt, setIsActiveHunt] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    checkForActiveHunt(setIsActiveHunt);
  }, []);

  return isActiveHunt ? (
    <>
      <button className={styles.rage} onClick={() => setShowModal(true)}>
        <img src="/images/scavenger-hunt/rage-animated.gif" alt="Rage" />
      </button>

      <SentimentModal isOpen={showModal} setShowModal={setShowModal} sentiment="rage" />
    </>
  ) : null;
}
